import React, { useContext } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import { HomepageContext } from '../context';
import avatarPhoto from '../../images/avatar.png';

const CustomersReview = () => {
  const { reviews } = useContext(HomepageContext);
  const items = reviews;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  if (items && items.length > 0) {
    return (
      <div className="CustomersReview">
        <Container>
          <Row>
            <Col>
              <h2 className="SectionHeading">Customers review</h2>
              <p className="CustomersReview-SubHeading">What our customer say about our services</p>
              <Slider {...settings}>
                {
                  items.map(item => (
                    <div key={item.id}>
                      <div className="CustomersReview-Item">
                        <Row>
                          <Col xs={12}>
                            <div className="d-flex align-items-center">
                              <div className="CustomersReview-Item__Avatar">
                                <Image src={avatarPhoto} className="rounded-circle" />
                              </div>
                              <span className="CustomersReview-Item__Rating">
                                {item.value} <FontAwesomeIcon size="xs" icon={faStar} />
                              </span>
                            </div>
                          </Col>
                          <Col xs={12}>
                            <p className="CustomersReview-Item__Content">{item.content}</p>
                            <h6 className="CustomersReview-Item__CustomerName mb-0">{item.name}</h6>
                            <p className="small text-secondary mb-0">{item.date}</p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ))
                }
                <div>
                  <div className="CustomersReview-Item">
                    <Row>
                      <Col xs={12}>
                        <div className="CustomersReview-Item__SeeMore">
                          <div className="d-block">
                            <Link 
                              to="!#" 
                              className="text-decoration-none"
                            >
                              <FontAwesomeIcon size="2x" color="#6c757d" icon={faCommentDots} />
                              <span className="d-block">See all reviews</span>
                            </Link>
                            <p className="text-secondary">We have more 360+ reviews, click the above link to check all of them.</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Slider>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return null;
};

export default CustomersReview;